import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

import { PostMediaAsset_Asset } from '~publish/components/PostCard/PostMedia/PostMediaAsset'

export const CommentsPostCard_Post = graphql(
  `
    fragment CommentsPostCard_Post on Post {
      __typename
      id
      status
      tags {
        id
        color
        name
      }
      metadata {
        __typename
        ... on CommonPostMetadata {
          type
        }
        ... on GoogleBusinessPostMetadata {
          title
        }
        ... on YoutubePostMetadata {
          title
        }
      }
      assets {
        __typename
        ...PostMediaAsset_Asset
      }
      dueAt
      schedulingType
      isCustomScheduled
      isPinned
      notificationStatus
      text
      channelId
      channelService
      externalLink
      channel {
        id
        service
        serviceId
        type
        name
        displayName
      }
    }
  `,
  [PostMediaAsset_Asset],
)

export type CommentsPostCard_PostData = ResultOf<typeof CommentsPostCard_Post>
